import React, { Component } from 'react';

export default class Contact extends Component {
    render(){
        return (
            <div className="container">
            <h3>Contact Us</h3>
                <div>

                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/contact.js